import getGtmDatalayer from './gtmDataLayer';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		const gtmData = getGtmDatalayer();
		window.gtmEnvironment = gtmData.environment;
		window.dataLayer = gtmData.dataLayer;
		window.onbeforeprint = null;
		window.onafterprint = null;
	},
};
export default controller;
